<template>
  <div v-if="isAdmin && isPromoteur">
    <div class="columns is-gapless has-background-white is-minH50p is-border-top is-marginless-bottom">
      <div class="column is-self-centered is-padding-left">
        <div class="is-uppercase is-size-6">
          Vendeur {{ index + 1 }}
        </div>
      </div>
      <div
        v-if="index > 0 && isAdmin && isPromoteur"
        class="column is-narrow is-border-left">
        <a
          class="column is-narrow has-background-white is-flex is-padding-small tooltip is-tooltip-top"
          @click="removeSellerShare(share)"
          data-tooltip="Supprimer le vendeur">
          <span class="icon has-text-grey is-size-4"><i class="fal fa-trash-alt"></i></span>
        </a>
      </div>
    </div>

    <div class="is-border-top is-padding-left is-padding-bottom  is-padding-right is-padding-top-small columns is-gapless has-background-light">
      <div class="column is-5 columns is-gapless is-vcentered is-multiline has-text-primary">
        <div class="column is-12 is-size-7 is-margin-bottom-xxsmall is-uppercase">
&nbsp;
        </div>
        <div class="column is-narrow is-margin-right">
          <avatar
            :item="share.user"
            :i="index"></avatar>
        </div>
        <div
          v-if="share.user"
          class="column">
          <b v-if="share.user">{{ share.user.last_name }} {{ share.user.first_name }}</b>
          <br v-if="share.user.account.pk !== currentUser.account.pk">
          <span v-if="share.user.account.pk !== currentUser.account.pk">Société {{ share.user.account.name }}</span>
        </div>
      </div>
      <div class="column is-4 columns is-gapless is-column is-margin-left has-text-primary">
        <div>
          <r-label
            :is-required="false"
            :label="'Taux de commission'"
            :for-id="`input${share.user.pk}`"
            class="has-text-primary"></r-label>
          <div
            v-if="isAdmin && isPromoteur"
            class="field has-addons">
            <v-input
              :name="`input${share.user.pk}`"
              @input="val => updateSellerRemuneration(val)"
              @focus="selectInput(`input${share.user.pk}`)"
              :model="remuneration"
              :errors-bag="errors"
              data-vv-value-path="val"
              classes="has-text-centered w90p"
              :max="100"
              :number="true"
              input-type="number"
              data-vv-as=" "
              icon="fa-percentage"
              v-validate="''"
              :has-incrementations="true"
              :step="0.1">
              <div class="control">
                <a class="button is-static is-border is-square">
                  <span class="icon"><i class="fas fa-percentage"></i></span>
                </a>
              </div>
            </v-input>
            <div
              class="control"
              v-if="displayNewTauxComButton">
              <button
                @click="updateSellerShare(share)"
                type="button"
                :disabled="loadSave"
                class="button is-success is-square tooltip is-tooltip-right"
                data-tooltip="Valider la modification du taux">
                <span class="icon">
                  <i
                    v-if="loadSave"
                    class="fas fa-spinner fa-spin"></i>
                  <i
                    v-else
                    class="fas fa-save"></i>
                </span>
              </button>
            </div>
            <div
              class="control"
              v-if="displayNewTauxComButton">
              <a
                @click="undoCom()"
                data-tooltip="Annuler la modification du taux"
                class="button tooltip is-tooltip-right is-square is-draft">
                <span class="icon has-text-white"><i class="fas fa-times"></i></span>
              </a>
            </div>
          </div>
          <div
            v-else
            class="field is-grouped adv-hero-inputDark">
            <div class="">
              {{ share.remuneration }} %
            </div>
          </div>
        </div>
      </div>
      <div class="column has-text-right has-text-primary">
        <div class="is-size-7 is-margin-bottom-xxsmall is-uppercase">
&nbsp;
        </div>
        <div class="has-text-weight-bold">
          {{ (share.total_ht).toFixed(2) }} € HT
        </div>
        <div>{{ (share.total_ttc).toFixed(2) }} € TTC</div>
      </div>
    </div>
  </div>
</template>

<script>
import { isNil, clone } from 'lodash'
import { Adv, Error } from '@/mixins'

export default {
  name: 'SellerFacturation',
  mixins: [Adv, Error],
  props: {
    share: Object,
    index: Number
  },
  data () {
    return {
      loadSave: false,
      displayNewTauxComButton: false,
      editShare: false,
      isNil,
      savedTauxCom: null
    }
  },
  created () {
    this.savedTauxCom = clone(this.share.remuneration)
    this.remuneration = clone(this.share.remuneration)
  },
  methods: {
    /**
      * undo remuneration
      */
    undoCom () {
      this.remuneration = this.savedTauxCom
      this.displayNewTauxComButton = false
    },
    /**
      * delete seller share
      * @param {object} share
      */
    async removeSellerShare (share) {
      try {
        await this.$api.axios.delete(`sales/${this.sale.pk}/users/${share.user.pk}`)
        // this.$toasted.success('Suppression de l\'utilisateur réussi')
        this.sale.users_in_sale.splice(this.index, 1)
      } catch (err) {
        console.log(err)
        this.$toasted.success('Erreur lors de la suppression')
      }
      try {
        const resa = await this.$api.axios.get(`reservations/${this.adv.pk}`)
        const resaData = resa.data.seller_to_send
        const sellerToDeleted = resaData.filter(x => x.pk !== share.user.pk)
        let dataToSend = {
          seller_to_send: sellerToDeleted
        }
        this.$store.commit('modifyCurrentAdv', { key: `seller_to_send`, value: sellerToDeleted })
        await this.$api.axios.patch(`reservations/${this.adv.pk}`, dataToSend)
        this.$toasted.success('Suppression de l\'utilisateur réussi')
      } catch (err) {
        console.log(err)
        this.$toasted.success('Erreur lors de la suppression')
      }
    },
    /**
      * select input by ref
      * @param {string} input - input ref
      */
    selectInput (input) {
      if (input in this.$refs) {
        if (Array.isArray(this.$refs[input])) {
          this.$refs[input][0].select()
        } else {
          this.$refs[input].select()
        }
      }
    },
    /**
      * update seller remuneration
      * @param {Number} val
      */
    updateSellerRemuneration (val) {
      this.displayNewTauxComButton = true
      this.editShare = true
      this.remuneration = val
    },
    /**
      * update seller share
      * @param {object} share
      */
    async updateSellerShare (share) {
      this.loadSave = true
      let payload = {
        remuneration: this.remuneration
      }
      try {
        let { data } = await this.$api.axios.patch(`sales/${this.sale.pk}/users/${share.user.pk}`, payload)
        this.$set(this.sale.users_in_sale, this.index, data)
        this.$toasted.success('Taux de commission mis a jour')
        this.savedTauxCom = clone(data.remuneration)
      } catch (err) {
        console.log(err)
      } finally {
        this.loadSave = false
        this.displayNewTauxComButton = false
        this.editShare = false
      }
    }
  }
}
</script>
